import {
    parseISO,
    differenceInSeconds,
    differenceInMinutes,
    differenceInHours,
    differenceInDays,
    format,
} from 'date-fns'

/**
 * Formats the timestamp of the messages displayed in the chat UIs.
 * @Example
 * - Last minute: Now
 * - Next minute: In a moment
 * - Last hour: 15 mins ago
 * - Next hour: 15 mins from now
 * - Last day: 5 hrs ago
 * - Next day: 5 hrs from now
 * - Last month: 10 days ago
 * - Next month: 10 days from now
 * - More than one month: November 24, 2020 - 09:14
 */
export const formatChatMessageDateTime = (dateStr: string) => {
    const date = parseISO(dateStr)
    const now = new Date()

    const secondsDiff = differenceInSeconds(date, now)
    if (Math.abs(secondsDiff) < 60) {
        return secondsDiff > 0 ? 'In a moment' : 'Now'
    }

    const minutesDiff = differenceInMinutes(date, now)
    if (Math.abs(minutesDiff) < 60) {
        return `${Math.abs(minutesDiff)} min${
            Math.abs(minutesDiff) === 1 ? '' : 's'
        } ${minutesDiff >= 0 ? 'from now' : 'ago'}`
    }

    const hoursDiff = differenceInHours(date, now)
    if (Math.abs(hoursDiff) < 24) {
        return `${Math.abs(hoursDiff)} hr${
            Math.abs(hoursDiff) === 1 ? '' : 's'
        } ${hoursDiff >= 0 ? 'from now' : 'ago'}`
    }

    const daysDiff = differenceInDays(date, now)
    if (Math.abs(daysDiff) <= 31) {
        return `${Math.abs(daysDiff)} day${
            Math.abs(daysDiff) === 1 ? '' : 's'
        } ${daysDiff >= 0 ? 'from now' : 'ago'}`
    }

    return format(date, 'MMMM dd, yyyy - HH:mm')
}
